import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface PaginationBarProps {
  page: number;
  totalPages: number;
  pageStart: number;
  pageEnd: number;
  totalItems: number;
  hasNext: boolean;
  hasPrev: boolean;
  next: () => void;
  prev: () => void;
  pageSize: number;
  setPageSize: (size: number) => void;
}

export function PaginationBar({
  pageStart, pageEnd, totalItems, hasNext, hasPrev, next, prev, pageSize, setPageSize,
}: PaginationBarProps) {
  if (totalItems <= 0) return null;
  return (
    <div className="flex items-center justify-between px-4 py-2 border-t bg-muted/20">
      <div className="flex items-center gap-2">
        <span className="text-[11px] text-muted-foreground">Rows per page:</span>
        <Select value={(pageSize ?? 20).toString()} onValueChange={(value) => setPageSize(Number(value))}>
          <SelectTrigger className="h-7 w-16 text-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="10">10</SelectItem>
            <SelectItem value="15">15</SelectItem>
            <SelectItem value="20">20</SelectItem>
            <SelectItem value="25">25</SelectItem>
            <SelectItem value="50">50</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <span className="text-[11px] text-muted-foreground">
        {pageStart}–{pageEnd} of {totalItems}
      </span>
      <div className="flex items-center gap-1">
        <Button variant="ghost" size="icon" className="h-7 w-7" disabled={!hasPrev} onClick={prev}>
          <ChevronLeft className="h-3.5 w-3.5" />
        </Button>
        <Button variant="ghost" size="icon" className="h-7 w-7" disabled={!hasNext} onClick={next}>
          <ChevronRight className="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  );
}
